export enum EConversorMlhEGotasType {
  MacroDrops = 'macrogotas',
  MicroDrops = 'microgotas',
  MlHour = 'mlh',
}

export interface IUseConversorMlhEGotas {
  quantity: number;
  setQuantity(value: number): void;
  setType(value: EConversorMlhEGotasType): void;
  type: EConversorMlhEGotasType;
}
